import { AccordionList } from "../../../../modules/content/components/AccordionList/AccordionList";
import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { IAccordionBlockProps } from "./AccordionBlock.props";

export const AccordionBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  openBehavior,
  parentClass,
  spacing,
}: IAccordionBlockProps) => {
  if (!items?.length) return null;
  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12 md:gap-16">
        <SproutCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="w-full self-end">
          <AccordionList items={items} openBehavior={openBehavior} />
        </div>
      </div>
    </SproutSection>
  );
};

AccordionBlock.displayName = "Block::AccordionBlock";
